import React, { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { useSWRFetch as useSearchFreeDeliveryPharmacy } from 'src/modules/apis/free-delivery/search/use-fetch'
import { PublicPageHeader } from 'src/modules/components/header/public-page-header'
import { View } from 'src/modules/components/lib/view'
import { getQueryParams } from 'src/modules/helpers/get-query-params'
import { NetApplicationFreeDeliverySearchScreen } from './screen'

export const NetApplicationFreeDeliverySearchScreenContainer: FC = () => {
  const { clinic_uid } = getQueryParams(['clinic_uid'])
  const { data, loading } = useSearchFreeDeliveryPharmacy({
    clinic_uid: clinic_uid ?? '',
  })

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <View minHeight="100%">
        <PublicPageHeader fetched={false} authorized={false} />
        <NetApplicationFreeDeliverySearchScreen
          nearestFreeDeliveryPharmacy={
            data?.nearestFreeDeliveryPharmacy ?? null
          }
          pharmacies={data?.pharmacies}
          isLoading={loading}
        />
      </View>
    </>
  )
}
